const GOOGLE_API_DOMAIN = 'googlemap.api.domain';
const GOOGLE_API_KEY = 'googlemap.api.key';
const GOOGLE_API_STREET_VIEW_PATH = 'googlemap.api.streetViewPath';
const GOOGLE_API_JS_PATH = 'googlemap.api.jsPath';
const GOOGLE_API_STATIC_PATH = 'googlemap.api.staticPath';
const GOOGLE_PLACE_URL = 'http://www.google.com/maps/place';

export {
  GOOGLE_API_DOMAIN,
  GOOGLE_API_KEY,
  GOOGLE_API_STREET_VIEW_PATH,
  GOOGLE_API_JS_PATH,
  GOOGLE_API_STATIC_PATH,
  GOOGLE_PLACE_URL,
};
